import { __require as require_getNative } from './_getNative.js';
import { __require as require_root } from './_root.js';

var _Set;
var hasRequired_Set;

function require_Set () {
	if (hasRequired_Set) return _Set;
	hasRequired_Set = 1;
	var getNative = require_getNative(),
	    root = require_root();

	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');

	_Set = Set;
	return _Set;
}

export { require_Set as __require };
//# sourceMappingURL=_Set.js.map
